import axios from 'axios'
import cryptojs from 'crypto-js'
import utils from '@/common/util/utils'
export default class VodObject {
  constructor () {
    this.adData = null
    this.adIndex = 0
    this.awsCookie = ''
    this.chargedType = ''
    this.concurrencyGroup = ''
    this.isAd = false
    this.isCharged = false
    this.isDrm = false
    this.isPreview = false
    this.isReady = false
    this.isVTT = false
    this.issue = ''
    this.purchaseBtns = null
    this.purchaseMsg = null
    this.previewMsg = ''
    this.priceType = ''
    this.vodUrl = ''
    this.vttPath = ''
    this.totalPlayTime = 0
    this.type = 'vod'
  }
  getVodUrl () {
    if (this.isAd) {
      return this.adData.ads[this.adIndex].content_url
    }
    else return this.vodUrl
  }
  changeAd () {
    if (this.isAd) {
      if (this.adIndex < this.adData.ads.length - 1) this.adIndex++
      else this.isAd = false
    }
  }
  getCurrentAdSkipTime () {
    let offsetTime = -1
    try {
      offsetTime = parseInt(this.adData.ads[this.adIndex].skip.offset)
    } catch (e) {

    }
    return offsetTime
  }
  isCurrentAdSkipAble () {
    if (this.isAd) return this.getCurrentAdSkipTime() > 0
    else return false
  }
  isAdClickAble () {
    let currAd = this.adData.ads[this.adIndex]
    let result = false
    if (Object.keys(currAd.tracking_url).length > 0) {
      if (currAd.tracking_url.click != null && currAd.tracking_url.click.length > 0) result = true
    }
    return result
  }
  getCurrClickUrl () {
    return this.adData.ads[this.adIndex].tracking_url.click
  }
  getAdDuration () {
    let duration = 0
    try {
      duration = parseInt(this.adData.ads[this.adIndex].duration)
    } catch (e) {

    }
    return duration
  }
  sendAdLog (expression) {
    let url = ''
    let tracking = this.adData.ads[this.adIndex].tracking_url
    switch (expression) {
      case 'start':
        url = tracking.start
        break;
      case 'quarter1':
        url = tracking.firstQuartile
        break;
      case 'quarter2':
        url = tracking.mid_point
        break;
      case 'quarter3':
        url = tracking.thirdQuartile
        break;
      case 'complete':
        url = tracking.complete
        break;
      case 'click':
        url = tracking.clickLog
        break;
      case 'skip':
        url = tracking.skip
        break;
      default:
    }
    this.adLogStep = expression
    axios.get(url)
  }
  setURL (data) {
    this.vodUrl = data.playurl
    this.awsCookie = data.awscookie
    if (this.awsCookie != null && this.awsCookie.length > 0) {
      var cookie01 = this.awsCookie.replace('CloudFront-Policy', 'Policy')
      var cookie02 = cookie01.replace('CloudFront-Signature', '&Signature')
      var cookie03 = cookie02.replace('CloudFront-Key-Pair-Id', '&Key-Pair-Id')
      var tmpUrl01 = this.vodUrl + '?' + cookie03
      var tmpUrl02 = tmpUrl01.replace(/;/gi, '')
      this.vodUrl = tmpUrl02
    }
  }
  setVodData (type, content, stream) {
    if (type != null) this.type = type
    switch (this.type) {
      case 'live':
        this.setLiveInfo(content)
        break
      default:
    }

    this.setURL(stream)
    this.setModifyNY(stream)
    this.setVttPath(stream)
    this.concurrencyGroup = stream.concurrencyGroup
    this.issue = stream.issue
    this.chargedType = stream.chargedtype
    this.priceType = stream.pricetype
    this.totalPlayTime = parseInt(this.isPreview ? stream.previewtime : stream.playtime)

    if (this.isReady) return
    //이미 ready 상태이면 광고 정보는 불러오지 않는다
    if (Object.keys(stream.prerollad).length > 0) {
      this.prerollad = stream.prerollad;
      var jwt = this.getJWTString(this.getADParam(this.prerollad))
      axios({
        method: 'post',
        url: this.prerollad.url,
        data: jwt,
        headers: {'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(({ data }) => {
        if (data.response != null) {
          if (data.ads != null && data.ads.length > 0) {
            this.setAdData(data)
          }
        }
        this.isReady = true
      }).catch(() => {
        this.isReady = true
      })
    }
    else this.isReady = true
  }
  setAdData (data) {
    this.isAd = true
    this.adData = data
  }
  setLiveInfo (data) {
    this.startTime = data.starttime
    this.endTime = data.endtime
  }
  setModifyNY (data, isDVR) {
    // if (Object.keys(data.preview).length === 0) {
    //   this.isPreview = false
    // } else {
    //   if (isDVR === true) this.isPreview = false
    //   else this.isPreview = true
    // }
    switch (data.play) {
      case 'y':
        this.isPreview = false
        this.isCharged = true// 현재 페이지에서 한번이라도 이용권한이 있었던 경우
        break
      case 'p':
        this.isPreview = true
        break
      case 'n':
        this.isPreview = true
        break
      default:
    }

    if (this.isPreview) this.previewMsg = data.preview.previewmsg

    if (Object.keys(data.drm).length > 0) this.isDrm = true
    else this.isDrm = false
  }
  setVttPath (data) {
    if (data.etcurl === null || data.etcurl === undefined) {
      this.isVTT = false
    } else {
      this.vttPath = data.etcurl + 'thumbnail.vtt'
      this.isVTT = true
    }
  }
  setPurchaseMsg (msg) {
    this.purchaseMsg = msg
  }
  setPurchaseBtns (str) {
    this.purchaseBtns = str
  }
  clearPurchaseMsg () {
    this.purchaseMsg = null
    this.purchaseBtns = null
  }
  generateID (media)
	{
		var requesttime = utils.getYMDHIS();
		var uuid = utils.generateRandomString(5) + media + requesttime
    console.log(uuid)
		return uuid
	}
  getADParam (data) {
    let param = new FormData()
    param.version = data.adapiversion
		param.media = data.media
		param.site = data.site
		param.requesttime = data.requesttime
		param.tid = String(cryptojs.MD5(this.generateID("POOQ")))
		param.uuid = String(cryptojs.MD5(utils.guid))
    param.ip = utils.cookies.getItem('for_wavve_ip')
    param.gender = data.gender
    param.age = data.age
    param.platform = "ssfamilyhub"
    param.playertype = "HTML5"
    param.os = 'ssfamilyhub'
    param.devicemodel = "ssfamilyhub"
    param.telco = ""
    param.cpid = data.cpid
    param.channelid = data.channelid
    param.category = data.category
    param.section = data.section
    param.programid = data.programid
    param.clipid = data.clipid
    param.referrer = data.referrer
    param.adlink = data.adlink
    param.contentnumber = data.contentnumber
    param.targetnation = data.targetnation
    param.isonair = data.isonair
    param.ispay = data.ispay
    param.vodtype = data.vodtype
    param.broaddate = data.broaddate
    param.playtime = data.playtime
    param.starttime = data.starttime
    param.endtime = data.endtime
    param.adtype = data.adtype
    param.customkeyword = data.customkeyword
    console.log(param)
		return param;
  }
  getJWTString (param)
	{
		function base64url(source)
		{
			var encodedSource = cryptojs.enc.Base64.stringify(source)
			encodedSource = encodedSource.replace(/=+$/, '')
			encodedSource = encodedSource.replace(/\+/g, '-')
			encodedSource = encodedSource.replace(/\//g, '_')

  			return encodedSource
		}
    var header = {
  						"alg": "HS256",
  						"typ": "JWT"
		};
		var stringifiedHeader = cryptojs.enc.Utf8.parse(JSON.stringify(header))
		var encodedHeader = base64url(stringifiedHeader)

		var stringifiedData = cryptojs.enc.Utf8.parse(JSON.stringify(param))
		var encodedData = base64url(stringifiedData)

		var token = encodedHeader + "." + encodedData

		var secret = '1d9b87e47123f4b4'//jarvis.playerInfo.SMR_ENC_KEY;
		var signature = cryptojs.HmacSHA256(token, secret)
		signature = base64url(signature)
		var signedToken = token + "." + signature
		return signedToken
	}
}
